import { trackEvent, trackPageview } from "@garantidos/utils/tracking"

const pageview = (hashedCpf) => {
  const ga4 = {
    customPath:
      "credito/cgimovel/quitado/contratacao/simulacao/seguir-por-web-ou-app",
    hashedCpf,
    implementationTeam: "cgi:v01"
  }

  const ga = {
    label: "IT:NL:NCC:CGI:Simulador:Simulador:SeguirPorWebOuApp",
    hashedCpf
  }

  trackPageview({ ga, ga4 })
}

const advanceToApp = (hashedCpf) => {
  const ga4 = {
    customPath:
      "credito/cgimovel/quitado/contratacao/simulacao/seguir-por-web-ou-app",
    hashedCpf,
    implementationTeam: "cgi:v01",
    detail: "seguir-por-web-ou-app-ir-para-app",
    eventName: "click"
  }

  const ga = {
    label: "BTN:SeguirPorWebOuApp:IrParaApp",
    category: "Clique",
    action: "Simulador",
    hashedCpf
  }

  trackEvent({ ga, ga4 })
}

const advanceToBrowser = (hashedCpf) => {
  const ga4 = {
    customPath:
      "credito/cgimovel/quitado/contratacao/simulacao/seguir-por-web-ou-app",
    hashedCpf,
    implementationTeam: "cgi:v01",
    detail: "seguir-por-web-ou-app-continuar-navegador",
    eventName: "click"
  }

  const ga = {
    label: "BTN:SeguirPorWebOuApp:ContinuarNoNavegador",
    category: "Clique",
    action: "Simulador",
    hashedCpf
  }

  trackEvent({ ga, ga4 })
}

const alert = (hashedCpf, error) => {
  const ga4 = {
    customPath:
      "credito/cgimovel/quitado/contratacao/simulacao/seguir-por-web-ou-app",
    hashedCpf,
    implementationTeam: "cgi:v01",
    eventName: "alert",
    description: "erro",
    detail: error.message
      ?.toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replaceAll(/ /g, "-")
      .replaceAll(/!/g, "")
  }

  trackEvent({ ga4 })
}

export { pageview, advanceToApp, advanceToBrowser, alert }
